<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Stock Take Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/stock-take">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>


        <v-divider></v-divider>

        <v-row class="subtitle-2 text--primary mb-2">
          <v-col cols="12" md="4">
            <span>Date: {{ Invoice.date | date }}</span><br/><br>
            <span>Total: {{ Invoice.DocTotal | currency }}</span><br/>
          </v-col>


        </v-row>

        <v-divider></v-divider>

        <v-row dense id="po" class="text--primary subtitle-2 mt-2">
          <v-col cols="12">
            <v-data-table
              light
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="Rows"
              item-key="id"
              hide-default-footer
            >
              <template v-slot:item.Name="{ item }">
                <span style="width: 200px">{{ item.product.Name }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                {{
                item.Quantity
                }}
              </template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{ item.Price | currency }}</span>
              </template>

              <template v-slot:item.DiscSum="{ item }">
                {{
                item.DiscSum
                }}
              </template>

              <template v-slot:item.LineTotal="{ item }">
                {{
                item.LineTotal | currency
                }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->
  </v-container>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    Invoice: {},
    TotalPaid: 0,
    Balance: 0,
    OutsourcedProducts: [],
    Rows: [],
    Payments: [],
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Unit", value: "Unit" },
    ]
  }),
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    }
  },
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/stock-take-records/${val}`)
        .then(res => {
          console.log(res, " stock take res");
          if (res.ResultCode == 1200) {
              self.Invoice = res.ResponseData.Invoice;
              self.Rows = res.ResponseData.StockTakeRows;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    generateReceipt() {},
    generateInvoice() {},
    generateDelivery() {},
    setDate(date) {
      this.record.DocDate = date;
    }
  },
  created() {}
};
</script>

<style  scoped>
/* .v-text-field__details {
  display: none !important;
} */
</style>